var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"icon-button",attrs:{"disabled":_vm.disabled},on:{"click":_vm.clickHandler}},[_c('span',{staticClass:"icon-button__text"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }